//@flow

import React from 'react';

import Hera from '../../../../assets/images/pages/pizza/fields/pizza_hera@3x.png';

type Props = {};

export default class PizzaCrust extends React.PureComponent<Props> {
  render() {
    return <img {...this.props} src={Hera} className="pizza-image pizza-hera" />;
  }
}
